import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default class ClearCacheRedisPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cacheKey: "",
            cacheValue: "",
            activeTab: "manual", // manual | build
            tableName: "",
            recordKey: "",
            loadingClear: false,
            loadingGet: false,
            loadingGetKeys: false,
            // memcache (GAE)
            memKind: "",
            memId: "",
            memRawKey: "",
            loadingMemcache: false,
        };
    }

    handleInputChange = (e) => {
        this.setState({ cacheKey: e.target.value });
    };

    buildKeyFromHost = () => {
        const { tableName, recordKey } = this.state;
        const host = window.location.hostname || "";

        if (!tableName || !tableName.trim() || !recordKey || !recordKey.trim()) {
            toast.warning("Vui lòng nhập đầy đủ Tên bảng và Key");
            return null;
        }

        const cleanTable = tableName.trim();
        const cleanKey = recordKey.trim();

        if (host.includes("dev") || host.includes("localhost")) {
            return `ikara4m-dev:${cleanTable}:${cleanKey}`;
        }

        if (host.includes("ikara.co") || host.includes("yokara.com")) {
            return `ikara4m:${cleanTable}:${cleanKey}`;
        }

        toast.error("Domain hiện tại không hỗ trợ build key Redis tự động");
        return null;
    };

    handleClearCache = (e) => {
        e.preventDefault();
        const { cacheKey, activeTab } = this.state;

        let finalKey = cacheKey;
        if (activeTab === "build") {
            const builtKey = this.buildKeyFromHost();
            if (!builtKey) return;
            finalKey = builtKey;
            this.setState({ cacheKey: builtKey });
        }

        if (!finalKey || !finalKey.trim()) {
            toast.warning("Vui lòng nhập key cache");
            return;
        }

        this.setState({ loadingClear: true });

        axios
            .post(
                `${global.config.apiDomain}/utility/redis/delete-cache`,
                { key: finalKey.trim() },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                this.setState({ loadingClear: false });
                // API trả 200 với body rỗng nếu xóa thành công
                toast.success("Đã xóa cache thành công");
                this.setState({ cacheValue: "" });
            })
            .catch((error) => {
                this.setState({ loadingClear: false });
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "Đã xảy ra lỗi khi xóa cache";
                toast.error(errorMessage);
                console.error("Clear cache error:", error);
            });
    };

    handleGetCache = (e) => {
        e.preventDefault();
        const { cacheKey, activeTab } = this.state;

        let finalKey = cacheKey;
        if (activeTab === "build") {
            const builtKey = this.buildKeyFromHost();
            if (!builtKey) return;
            finalKey = builtKey;
            this.setState({ cacheKey: builtKey });
        }

        if (!finalKey || !finalKey.trim()) {
            toast.warning("Vui lòng nhập key cache");
            return;
        }

        this.setState({ loadingGet: true });

        axios
            .post(
                `${global.config.apiDomain}/utility/redis/get-cache`,
                { key: finalKey.trim() },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                this.setState({ loadingGet: false });
                // 200: trả về value đang lưu trong Redis (object/string/...)
                const value = res.data;
                const text =
                    typeof value === "string"
                        ? value
                        : JSON.stringify(value, null, 2);
                this.setState({ cacheValue: text });
                toast.success("Lấy cache thành công");
            })
            .catch((error) => {
                this.setState({ loadingGet: false, cacheValue: "" });
                if (error.response && error.response.status === 404) {
                    toast.warning("Key không tồn tại trong Redis");
                } else {
                    const errorMessage =
                        error.response?.data?.message ||
                        error.message ||
                        "Đã xảy ra lỗi khi lấy cache";
                    toast.error(errorMessage);
                }
                console.error("Get cache error:", error);
            });
    };

    handleGetKeys = (e) => {
        e.preventDefault();
        const { cacheKey, activeTab } = this.state;

        let finalKey = cacheKey;
        if (activeTab === "build") {
            const builtKey = this.buildKeyFromHost();
            if (!builtKey) return;
            finalKey = builtKey;
            this.setState({ cacheKey: builtKey });
        }

        if (!finalKey || !finalKey.trim()) {
            toast.warning("Vui lòng nhập pattern key (ví dụ: ikara4m:User:*)");
            return;
        }

        this.setState({ loadingGetKeys: true });

        axios
            .post(
                `${global.config.apiDomain}/utility/redis/get-keys`,
                {
                    pattern: finalKey.trim(),
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                this.setState({ loadingGetKeys: false });
                // Response 200 (ví dụ): ["user:1", "user:2", ...]
                const keys = res.data || [];
                let text = "";
                if (Array.isArray(keys)) {
                    text = keys.join("\n");
                } else if (typeof keys === "string") {
                    text = keys;
                } else {
                    text = JSON.stringify(keys, null, 2);
                }

                this.setState({ cacheValue: text });
                if (!text) {
                    toast.warning("Không tìm thấy keys nào");
                } else {
                    toast.success("Lấy danh sách keys thành công");
                }
            })
            .catch((error) => {
                this.setState({ loadingGetKeys: false, cacheValue: "" });
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "Đã xảy ra lỗi khi lấy danh sách keys";
                toast.error(errorMessage);
                console.error("Get keys error:", error);
            });
    };

    handleDeleteKeysByPattern = (e) => {
        e.preventDefault();
        const { cacheKey, activeTab } = this.state;

        let finalPattern = cacheKey;
        if (activeTab === "build") {
            const builtKey = this.buildKeyFromHost();
            if (!builtKey) return;
            finalPattern = builtKey;
            this.setState({ cacheKey: builtKey });
        }

        if (!finalPattern || !finalPattern.trim()) {
            toast.warning("Vui lòng nhập pattern để xóa (ví dụ: user:*)");
            return;
        }

        this.setState({ loadingClear: true });

        axios
            .post(
                `${global.config.apiDomain}/utility/redis/delete-keys`,
                {
                    pattern: finalPattern.trim(),
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                this.setState({ loadingClear: false });
                const deletedCount = res.data;
                toast.success(`Đã xóa ${deletedCount} key theo pattern`);
            })
            .catch((error) => {
                this.setState({ loadingClear: false });
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "Đã xảy ra lỗi khi xóa nhiều keys";
                toast.error(errorMessage);
                console.error("Delete keys error:", error);
            });
    };

    handleClearMemcache = (e) => {
        e.preventDefault();
        const { memKind, memId, memRawKey } = this.state;

        const kind = (memKind || "").trim();
        const id = (memId || "").trim();
        const rawKey = (memRawKey || "").trim();

        if (!rawKey && (!kind || !id)) {
            toast.warning(
                "Vui lòng nhập Raw key, hoặc đủ cả Tên bảng (Kind) và ID"
            );
            return;
        }

        this.setState({ loadingMemcache: true });

        axios
            .post(
                `${global.config.apiDomain}/rest/memcache/delete-cache`,
                {
                    key: rawKey || null,
                    kind: kind || null,
                    id: id || null,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                this.setState({ loadingMemcache: false });
                const data = res.data || {};
                if (data.status === "OK") {
                    toast.success(data.message);
                } else {
                    toast.warning(data.message || "Xóa memcache thất bại");
                }
                // In kết quả từng key: có trong cache trước khi xóa hay không
                const results = Array.isArray(data.results) ? data.results : [];
                if (results.length > 0) {
                    const text = results
                        .map(
                            (r) =>
                                `${r.key}\n  → ${
                                    r.existed
                                        ? "CÓ trong memcache, đã xóa"
                                        : "KHÔNG có trong memcache"
                                }`
                        )
                        .join("\n");
                    this.setState({ cacheValue: text });
                }
            })
            .catch((error) => {
                this.setState({ loadingMemcache: false });
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "Đã xảy ra lỗi khi xóa memcache";
                toast.error(errorMessage);
                console.error("Clear memcache error:", error);
            });
    };

    render() {
        const {
            cacheKey,
            cacheValue,
            activeTab,
            tableName,
            recordKey,
            loadingClear,
            loadingGet,
            loadingGetKeys,
            memKind,
            memId,
            memRawKey,
            loadingMemcache,
        } = this.state;

        return (
            <div
                className="container-fluid"
                style={{ marginTop: "100px", marginBottom: "20px" }}
            >
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <div className="card">
                            <div className="card-header bg-danger text-white">
                                <h3 className="card-title mb-0">
                                    <i className="fa-solid fa-trash mr-2"></i>
                                    Xóa cache Redis
                                </h3>
                            </div>
                            <div className="card-body">
                                {/* Tabs */}
                                <ul className="nav nav-tabs mb-3">
                                    <li className="nav-item">
                                        <button
                                            type="button"
                                            className={
                                                "nav-link " +
                                                (activeTab === "manual" ? "active" : "")
                                            }
                                            onClick={() =>
                                                this.setState({
                                                    activeTab: "manual",
                                                })
                                            }
                                        >
                                            Nhập key trực tiếp
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            type="button"
                                            className={
                                                "nav-link " +
                                                (activeTab === "build" ? "active" : "")
                                            }
                                            onClick={() =>
                                                this.setState({
                                                    activeTab: "build",
                                                })
                                            }
                                        >
                                            Build key theo bảng + key
                                        </button>
                                    </li>
                                </ul>

                                <form>
                                    {/* Tab 1: nhập key trực tiếp */}
                                    {activeTab === "manual" && (
                                        <div className="form-group">
                                            <label htmlFor="cacheKey">
                                                <strong>Key cache *</strong>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="cacheKey"
                                                name="cacheKey"
                                                value={cacheKey}
                                                onChange={this.handleInputChange}
                                                placeholder="Nhập key cache (ví dụ: ikara4m:User:3103154...)"
                                                disabled={loadingClear || loadingGet}
                                            />
                                        </div>
                                    )}

                                    {/* Tab 2: build key từ tên bảng + key */}
                                    {activeTab === "build" && (
                                        <>
                                            <div className="alert alert-info">
                                                Sẽ tự build key theo dạng{" "}
                                                <code>
                                                    ikara4m[-dev]:{"{"}Tên bảng{"}"}:{"{"}Key{"}"}
                                                </code>{" "}
                                                dựa theo domain hiện tại.
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="tableName">
                                                    <strong>Tên bảng *</strong>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="tableName"
                                                    name="tableName"
                                                    value={tableName}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            tableName: e.target.value,
                                                        })
                                                    }
                                                    placeholder="Ví dụ: User, LiveRoom, Recording..."
                                                    disabled={loadingClear || loadingGet || loadingGetKeys}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="recordKey">
                                                    <strong>Key *</strong>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="recordKey"
                                                    name="recordKey"
                                                    value={recordKey}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            recordKey: e.target.value,
                                                        })
                                                    }
                                                    placeholder="Ví dụ: 3103154193182968"
                                                    disabled={loadingClear || loadingGet || loadingGetKeys}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>
                                                    <strong>Key sau khi build</strong>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={cacheKey}
                                                    readOnly
                                                    placeholder="Key sẽ hiển thị ở đây sau khi bấm Xóa cache hoặc Get cache"
                                                />
                                            </div>
                                        </>
                                    )}

                                    <div className="form-group d-flex flex-wrap">
                                        <button
                                            type="button"
                                            className="btn btn-danger mr-2 mb-2"
                                            onClick={this.handleClearCache}
                                            disabled={loadingClear || loadingGet || loadingGetKeys}
                                        >
                                            {loadingClear ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm mr-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    Đang xóa cache...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-trash mr-2"></i>
                                                    Xóa cache
                                                </>
                                            )}
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-secondary mb-2"
                                            onClick={this.handleGetCache}
                                            disabled={loadingClear || loadingGet || loadingGetKeys}
                                        >
                                            {loadingGet ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm mr-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    Đang lấy cache...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-magnifying-glass mr-2"></i>
                                                    Get cache
                                                </>
                                            )}
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-info ml-2 mb-2"
                                            onClick={this.handleGetKeys}
                                            disabled={loadingClear || loadingGet || loadingGetKeys}
                                        >
                                            {loadingGetKeys ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm mr-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    Đang GET keys...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-list mr-2"></i>
                                                    GET keys
                                                </>
                                            )}
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-warning ml-2 mb-2"
                                            onClick={this.handleDeleteKeysByPattern}
                                            disabled={loadingClear || loadingGet || loadingGetKeys}
                                        >
                                            {loadingClear && !loadingGet && !loadingGetKeys ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm mr-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    Đang xóa theo pattern...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-broom mr-2"></i>
                                                    Xóa nhiều keys (pattern)
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            <strong>Kết quả cache</strong>
                                        </label>
                                        <textarea
                                            className="form-control"
                                            rows="8"
                                            value={cacheValue || ""}
                                            readOnly
                                            placeholder="Giá trị cache (nếu có) sẽ hiển thị ở đây..."
                                            style={{ fontFamily: "monospace" }}
                                        ></textarea>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Xóa memcache cũ (App Engine) — xóa trực tiếp, đồng bộ */}
                        <div className="card mt-4">
                            <div className="card-header bg-warning">
                                <h3 className="card-title mb-0">
                                    <i className="fa-solid fa-broom mr-2"></i>
                                    Xóa memcache (GAE)
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="alert alert-info">
                                    Nhập <strong>Tên bảng (Kind) + ID</strong> để xóa cache
                                    entity (tự build url-safe key, xóa cả biến thể ID số và
                                    chuỗi), hoặc nhập <strong>Raw key</strong> nếu có sẵn.
                                    Xóa trực tiếp trong memcache, kết quả từng key hiển thị
                                    ở ô "Kết quả cache" phía trên.
                                </div>
                                <form>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="memKind">
                                                <strong>Tên bảng (Kind)</strong>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="memKind"
                                                value={memKind}
                                                onChange={(e) =>
                                                    this.setState({ memKind: e.target.value })
                                                }
                                                placeholder="Ví dụ: User, Recording, InappPurchaseProduct..."
                                                disabled={loadingMemcache}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="memId">
                                                <strong>ID</strong>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="memId"
                                                value={memId}
                                                onChange={(e) =>
                                                    this.setState({ memId: e.target.value })
                                                }
                                                placeholder="Ví dụ: 3103154193182968"
                                                disabled={loadingMemcache}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="memRawKey">
                                            <strong>Hoặc Raw key</strong>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="memRawKey"
                                            value={memRawKey}
                                            onChange={(e) =>
                                                this.setState({ memRawKey: e.target.value })
                                            }
                                            placeholder="Url-safe key string hoặc key memcache tự đặt"
                                            disabled={loadingMemcache}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={this.handleClearMemcache}
                                        disabled={loadingMemcache}
                                    >
                                        {loadingMemcache ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm mr-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Đang gửi yêu cầu xóa...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa-solid fa-trash mr-2"></i>
                                                Xóa memcache
                                            </>
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


